<app-toaster
    *ngFor="let toast of toasts; let i = index"
    [toast]="toast"
    [i]="i"
    (remove)="remove($event)"
></app-toaster>
